/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const permSet = new Set(currentUser?.permissions ?? []);
  const isSuperAdmin = currentUser?.access === 'admin';
  return {
    canAdmin: currentUser && currentUser.access === 'admin',
    hasPerm: (code: string) => isSuperAdmin || permSet.has('*') || permSet.size === 0 || permSet.has(code),
  };
}
